<template>
    <div>
        <table class="tbl">
            <colgroup>
                <col style="width:167px">
                <col style="width:auto">
            </colgroup>
            <tbody>
                <tr>
                    <th>{{label.pricePlan}}</th>
                    <td>
                        {{serviceInfo.pricePlanName}}{{serviceInfo.pricePlanDetail}}
                    </td>
                </tr>
                <tr>
                    <th>{{label.serviceStartDate}}</th>
                    <td>{{formattedServiceStartDate}}</td>
                </tr>
                <tr>
                    <th>{{label.sipNumberInfo}}</th>
                    <td>
                        <div style="width:100%; height:100%; min-width:0px">
                            <div style="float:left; height:100%; display:flex; align-items:center">{{sipNumberInfo}}</div>
                            <div style="float:right;"><ur-button class="sr_btn" @click="onClickSRButton" large primary><i class="sr_icon"/> 변경 요청하기</ur-button></div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th/>
                    <td><ur-data-grid ref="grid" :options="options" :headers="headers" :data-source="items"/></td>
                </tr>
            </tbody>
        </table>
        <!--
        <div>
            <span class="label">{{label.pricePlan}}</span>
            <span>
                <span class="link" @click="onClickPricePlanName">{{serviceInfo.pricePlanName}}</span>
                <span>{{serviceInfo.pricePlanDetail}}</span>
            </span>
        </div>
        <div>
            <span class="label">{{label.serviceStartDate}}</span>
            <span>{{serviceStartDate}}</span>
        </div>
        <div style="display:inline-flex">
            <div class="label">{{label.sipNumberInfo}}</div>
            <div>
                <ur-data-grid class="no-min-width" ref="grid" :options="options" :headers="headers" :data-source="items"/>
            </div>
        </div>
        -->
        <!--
        <ur-form-box column="1">
            <ur-form-item :label="label.pricePlan">
                <span class="link" @click="onClickPricePlanName">{{serviceInfo.pricePlanName}}</span>
                <span>{{serviceInfo.pricePlanDetail}}</span>
            </ur-form-item>
            <ur-form-item :label="label.serviceStartDate">
                <span>{{serviceStartDate}}</span>
            </ur-form-item>
            <ur-form-item :label="label.sipNumberInfo">
                <div style="width:100%; height:100%">
                    <div style="float:left; height:100%; display:flex; align-items:center">{{sipNumberInfo}}</div>
                    <div style="float:right; display:inline-block"><ur-button @click="onClickSRButton"><img src="/src/assets/images/aicc/ic_campaign_w.png"/> 변경 요청하기</ur-button></div>
                </div>
            </ur-form-item>
            <ur-form-item label="" noHeight>
                <ur-data-grid class="no-min-width" ref="grid" :options="options" :headers="headers" :data-source="items"/>
            </ur-form-item>
        </ur-form-box>
        -->
    </div>
</template>
<script>
//import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';
import PGE_AIM_00001_C01 from './PGE_AIM_00001_C01';
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';

export default {
    name:'PGE_AIM_00001_T01',
    props:{
        serviceStartDate:{type:String, default:'',},
        items:{type:Array, default: () => []},
        height:{type:Number, default: 0}
    },
    components:{
        urDataGrid,
        comp:PGE_AIM_00001_C01,
    },
    data(){
        return {
            label:{
                pricePlan:'',
                serviceStartDate:'',
                sipNumberInfo:'',
            },
            serviceInfo:{
                pricePlanName:'',
                pricePlanDetail:'',
                //serviceStartDate:'',
                sipNumberInfo:'',
            },


            headers:[
                {text:'전화번호', value:'sipNumber', sort:true, 
                    customValue:(v,r) => {
                        return aiccUtils.phoneNumberFormat.format(v)
                    },
                },
                {text:'채널', value:'channels', sort:true, },
                {text:'발신번호', value:'callerId', sort:true,
                    customValue:(v,r) => aiccUtils.phoneNumberFormat.format(v),
                },
                {text:'이름', value:'description', sort:true,
                    component:PGE_AIM_00001_C01,
                },
                {text:'신청일', value:'useRequestDTM', sort:true,
                    customValue:(v,r) => utils.toStringByFormat(utils.toDate(v), 'YYYY-MM-DD')
                },
           ],
        }
    },
    created(){},
    mounted(){
        this.init();
    },
    computed:{
        options(){
            let options = {
                noInfo:true,
                //infinityScroll : this.infinityScroll(),
                infinityScroll:true,
                height:this.height,
                //height:this.gridHeight(),
                //height:870,
                headerHeight:48,
                rowHeight:49,
            };
            return options;
        },
        formattedServiceStartDate(){
            return utils.toStringByFormat(utils.toDate(this.serviceStartDate), 'YYYY-MM-DD');
        },
        sipNumberInfo(){
            let numberSum = 0;
            let channelsSum = 0;
            for(let index in this.items) {
                numberSum++;
                channelsSum += this.items[index].channels;
            }
            return this.serviceInfo.sipNumberInfo.replace('%(%N1)', numberSum).replace('%(%N2)', channelsSum);
        },
    },
    methods:{
        init(){
            this.label.pricePlan = '요금제';
            this.label.serviceStartDate = '서비스 시작일';
            this.label.sipNumberInfo = '사용 전화번호 / 채널';

            this.serviceInfo.pricePlanName = '스탠다드 요금제 ';
            this.serviceInfo.pricePlanDetail = '(최소 전화번호 1회선 | 4채널 선택)';
            this.serviceInfo.sipNumberInfo = '전화번호 %(%N1)개 / 채널 %(%N2)개';
        },
        /*
        infinityScroll(){
            if(this.items.length > 5) {
                return true;
            } else {
                return false;
            }
        },
        gridHeight(){
            if(this.items.length > 5) {
                return 270;
            } else {
                return null;
            }
        },
        */
        onClickSRButton(){
            this.$emit('onClickSRButton');
        },
    },
}
</script>
<style lang="scss" scoped>
    .tbl {
        width: 100%;
        border: 0;
        margin-top: 36px;
    }
    .tbl th {
        border: 0;
        padding: 16px 0 16px 0;
        line-height: 24px;
        font-size: 16px;
        color: #333;
        font-weight: 500;
        vertical-align: top;
        overflow: inherit;
        text-align: left;
    }
    .tbl td {
        border: 0;
        padding: 16px 0;
        line-height: 24px;
        font-size: 16px;
        color: #333;
        vertical-align: top;
        overflow: inherit;
        text-align: left;
        font-weight: 400;
    }
    .ur-data-grid {
        min-width:0;
        width:100%;
    }
    .link {
        text-decoration: underline;
        min-width:0px;
    }
    .sr_btn {
        font-size: 14px;
        padding: 0 16px;
    }
    .sr_icon {
        background-image: url('../../../../../assets/images/aicc/ic_request.png');
        width: 16px;
        height: 16px;
        display: inline-block;
        position: relative;
        top: 1px;
        margin-right: 4px;
    }
    
    /*
    .ur-button--border.ur-button--default {
        color: #516AF4;
        border: 1px solid #4155C3;
    }
    */
</style>